import React from 'react';
import { Youtube } from 'lucide-react';
import { Input } from '@components/ui/input';
import type { EmbedBlock } from '@staty/shared/schemas/block';
import { BlockView } from '@staty/shared/components/BlockRenderer';

/**
 * Video/embed block: empty state is a URL prompt; once a URL is set, the
 * shared BlockView renders the same 16:9 iframe the public page shows.
 * The URL itself is edited here inline (and also in the settings panel).
 */

interface Props {
  block: EmbedBlock;
  selected: boolean;
  onChange: (patch: Partial<EmbedBlock>) => void;
}

export default function EmbedBlockEditor({ block, selected, onChange }: Props) {
  if (!block.url) {
    return (
      <div className="canvas-block-empty">
        <Youtube className="h-5 w-5" />
        <div className="canvas-block-empty__body">
          <p>Paste a YouTube, Vimeo, or Maps link</p>
          <Input
            type="text"
            placeholder="https://www.youtube.com/watch?v=…"
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              const url = e.target.value.trim();
              if (url) onChange({ url });
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="canvas-embed">
      <BlockView block={block} />
      {/* The iframe would swallow clicks/drags — an overlay keeps the block
          selectable on the canvas; playback belongs on the public page. */}
      {!selected && <div className="canvas-embed__shield" />}
    </div>
  );
}
